import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, Modal, Label, Select, TextInput, Alert } from "flowbite-react";
import ReusableDataTable from '../../../hooks/ReusableDataTable';
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { FaPen, FaPlus } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { TbCircleLetterRFilled } from "react-icons/tb";
import { FaRectangleList } from "react-icons/fa6";
import axios from "axios";
import CGroupBoxingQuantity from './CGroupBoxingQuantity';
import RequestActivityModal from '../../../hooks/RequestActivityModal';

function GroupBoxing({ orderid }) {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [deleteId, setdeleteId] = useState();
    const [completeStatusKey, setcompleteStatusKey] = useState(0) //for re rende
    const url = localStorage.getItem("url");
    const [requestModal, setrequestModal] = useState(false);
    const [Input, setInput] = useState({});
    const [requestActivityModal, setrequestActivityModal] = useState(false);
    const [requestActivityData, setrequestActivityData] = useState({});
    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {
            fetchBoxing();
        }
    }, [user, navigate]);

    const onChangeValue = (e) => {
        setInput({ ...Input, [e.target.name]: e.target.value });
    };

    const [data, setData] = useState([]);

    const role = sessionStorage.getItem('role');

    const fetchBoxing = async () => {
        try {
            const response = await axios.get(`/group_boxing/group_boxing/${orderid}`);
            const result = response.data;
            setData(result);
            console.log(data)
        } catch (error) {
            console.error("Error fetching logs:", error);
        }
    };


    const fetchrequestActivity = async (bog_log_Id) => {
        try {
            const response = await axios.get(`/requests/request/${bog_log_Id}`, {
                params: { section_name: 'GroupBoxing' },
            });
            const requestActivityData = response.data.data;
            setrequestActivityData(requestActivityData);
        } catch (error) {
            console.error("Error fetching requestActivityData:", error);
        }
    };

    const handleRequest = async (e) => {
        e.preventDefault();

       
        const requestData = {
            ...Input,
            order_id: orderid,
            staff_id: user.staff_id,
            section_name: 'GroupBoxing',
            section_id: Input.id,
            reason: Input.reason
        };
        try {
            axios
                .post('/group_boxing/request', requestData)
                .then((response) => {
                    if (response.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Requested",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setrequestModal(false)
                        fetchBoxing();
                    }
                    else if(response.data.success === 2)
                    {
                        Swal.fire({
                            icon: "error",
                            text: "Please fill the values",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }
    };

    const handleDelete = async () => {
        try {
            axios.delete(`/group_boxing/group_boxing/${deleteId}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Boxing  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    setcompleteStatusKey((prevKey) => prevKey + 1);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };


    const columns = [
        { name: "#", selector: (row) => row.sno, sortable: true },
        { name: "Date", selector: (row) => row.date, sortable: true },
        { name: "Staff Name", selector: (row) => row.staffname, sortable: true },
        { name: "Box No", selector: (row) => row.box_no, sortable: true },
        { name: "Size with quantity", selector: (row) => row.formatedmarkerwithquantity, sortable: true },
        { name: "Total Piece", selector: (row) => row.totalpiece, sortable: true },

        ...(role === 'Finishing_Staff' || role === 'super_admin' || role === 'FM'
            ? [
                { name: "Option", selector: (row) => row.option }]
            : [])
    ];


    const Data = data?.map((plan, index) => {
        const currentDate = new Date().toLocaleDateString('en-GB');
        const planDate = new Date(plan.datatime).toLocaleDateString('en-GB');

        return {
            sno: index + 1,
            id: plan.group_boxing_log_id,
            date: new Date(plan.date).toLocaleDateString('en-GB'),
            formatedmarkerwithquantity: plan.formated_size_variant_quantity,
            markerwithquantity: plan.formated_size_variant,
            totalpiece: plan.total_piece,
            box_no: plan.box_no,
            datetime: plan.datatime,
            staffname: plan.staff_name,
            option:

                <div style={{ display: "flex" }}>
                    {(role === 'super_admin' || ((role === 'Finishing_Staff' || role === 'FM') && currentDate === planDate) || ((role === 'FM' && plan.request_status == 'accepted'))) && (
                        <>
                            <FaPen
                                className="text-amber-400 text-xl cursor-pointer"
                                onClick={() => { navigate(`/updateboxing?id=${orderid}&bid=${plan.group_boxing_log_id}`) }}
                            />
                            <MdDeleteForever
                                className="ml-2 text-red-500 text-2xl"
                                onClick={() => {
                                    setdeleteId(plan.group_boxing_log_id);
                                    handleDelete();
                                }}
                            />
                        </>

                    )}

                    {(role === 'FM' && currentDate !== planDate && plan.request_status != 'accepted') && (

                        <TbCircleLetterRFilled
                            className="text-green-500 text-xl "
                            onClick={() => {
                                (plan.request_status == 'request' || plan.request_status == "rejected") && setrequestModal(true); setInput({ id: plan.group_boxing_log_id });
                            }}
                            style={{
                                color: plan.request_status == 'requested' ? "grey" : "green",
                                cursor: plan.request_status == 'requested' ? "not-allowed" : "pointer",
                            }}
                        />

                    )}
                    {(role === 'FM' || role === 'super_admin') &&
                        <FaRectangleList
                            className="pl-1 text-blue-500 text-2xl" 
                            onClick={() => {
                                fetchrequestActivity(plan.group_boxing_log_id);
                                setrequestActivityModal(true);

                            }}
                        />}
                </div>

        };
    }) || [];

    return (
        <>
            {(role === 'Finishing_Staff' || role === 'super_admin' || role === 'FM') &&
                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" onClick={() => { navigate(`/addboxing?id=${orderid}`) }}>
                    Add Boxing
                </Button>}

            <CGroupBoxingQuantity key={completeStatusKey} orderid={orderid} />

            <div className="overflow-x-auto mt-2">
                <ReusableDataTable columns={columns} data={Data} />
            </div>

            <Modal
                show={requestModal}
                size="md"
                onClose={() => setrequestModal(false)}
                popup
            >
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to request admin access for editing?
                        </h3>

                    </div>
                    <div className="space-y-6">

                        <form>
                            <div>
                                <div className="pt-2 text-left mb-2 block">
                                    <Label htmlFor="completed-date" value="Reason" />
                                </div>
                                <TextInput
                                    id="reason"
                                    name="reason"
                                    type="text"
                                    required
                                    autoComplete="off"
                                    onChange={onChangeValue}
                                />
                            </div>

                            <div className="pt-3 w-full flex justify-center">
                                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit" onClick={(e) => handleRequest(e)}>
                                    Yes
                                </Button>
                                <Button className="ml-2" color="gray" onClick={() => setrequestModal(false)}>
                                    No
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <RequestActivityModal
                show={requestActivityModal}
                onClose={() => setrequestActivityModal(false)}
                requestActivityData={requestActivityData}
            />

        </>
    );
}

export default GroupBoxing;
